module.exports = __webpack_public_path__ + "assets/img/icons8-spinning-circle.8933193d.gif";